module.exports = __webpack_public_path__ + "static/media/household_story_1.fe13fa2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/household_story_1.png
// module id = 330
// module chunks = 0